import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_LATEST_NEWS,
    GET_SINGLE_LATEST_NEWS,
} from './newsTypes'

export default (state, action) => {
    switch (action.type) {
        case GET_LATEST_NEWS:
            return {
                ...state,
                latest_news: action.payload,
            }
        case GET_SINGLE_LATEST_NEWS:
            return {
                ...state,
                single_news: action.payload,
            }
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
